import { Box, styled } from "@mui/material";
import IconProps from "@/app/interfaces/props/IconProps";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ColorTokensEnum } from "../../../../enums/tokens/colorTokensEnum";
import {
  brandColors,
  resolveColorToken,
} from "../../../../stories/helpers/ColorTokenHelper";
import { SizeTokensEnum } from "../../../../enums/tokens/sizeTokensEnum";
import { radii } from "../../../../stories/helpers/RadiusTokenHelper";
import { RadiusTokensEnum } from "../../../../enums/tokens/radiusTokensEnum";

const sizeMap: Record<SizeTokensEnum, number> = {
  XS: 18,
  S: 24,
  M: 32,
  L: 42,
  XL: 48,
};

const notificationSizeMap: Record<SizeTokensEnum, number> = {
  XS: 6,
  S: 8,
  M: 8,
  L: 12,
  XL: 12,
};

const IconWrapper = styled(Box)<{ ownerState: { size: keyof typeof sizeMap } }>(
  ({ ownerState }) => ({
    position: "relative",
    display: "inline-flex",
    width: sizeMap[ownerState.size],
    height: sizeMap[ownerState.size],
    alignItems: "center",
    justifyContent: "center",
  })
);

const Notification = styled("div")<{
  ownerState: { size: keyof typeof notificationSizeMap };
}>(({ ownerState }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  width: notificationSizeMap[ownerState.size],
  height: notificationSizeMap[ownerState.size],
  backgroundColor: brandColors[ColorTokensEnum.ERROR],
  borderRadius: radii[RadiusTokensEnum.PILL],
  border: "1px solid #FFFFFF",
  zIndex: 1,
  transform: "translate(25%, -25%)",
}));

export const IconSB = ({
  size = SizeTokensEnum.M,
  notification = false,
  iconInstance = <ChevronRightIcon />,
  color = ColorTokensEnum.DARK_GREY,
}: IconProps) => {
  const resolvedColor = resolveColorToken(
    color,
    brandColors[ColorTokensEnum.DARK_GREY]
  );

  return (
    <IconWrapper ownerState={{ size }}>
      <Box
        sx={{
          display: "flex",
          fontSize: sizeMap[size as keyof typeof sizeMap],
          color: resolvedColor,
          "& svg": {
            fontSize: "inherit",
            color: resolvedColor,
          },
        }}
      >
        {iconInstance}
      </Box>
      {notification && <Notification ownerState={{ size }} />}
    </IconWrapper>
  );
};
